import React, { useEffect, useRef } from "react";

// Desktop-only fountain pen cursor.
// Detects pointer via media query and only mounts on devices with a fine pointer.
const Cursor = () => {
  const elRef = useRef(null);

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;

    document.body.classList.add("pen-cursor");
    const el = elRef.current;
    if (!el) return;

    let raf;
    let tx = 0;
    let ty = 0;
    let cx = 0;
    let cy = 0;

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };
    const onDown = () => el.classList.add("click");
    const onUp = () => el.classList.remove("click");

    const tick = () => {
      cx += (tx - cx) * 0.28;
      cy += (ty - cy) * 0.28;
      el.style.left = `${cx}px`;
      el.style.top = `${cy}px`;
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mousedown", onDown);
    window.addEventListener("mouseup", onUp);
    raf = requestAnimationFrame(tick);

    return () => {
      document.body.classList.remove("pen-cursor");
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("mouseup", onUp);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <svg
      ref={elRef}
      className="pen-cursor-el"
      viewBox="0 0 36 36"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* fountain pen body */}
      <g>
        <path
          d="M3 33 L7 29 L23 13 L29 19 L13 35 L3 35 Z"
          fill="#0e0e0e"
        />
        <path d="M3 33 L8 35 L13 35 L7 29 Z" fill="#7c0e1a" />
        <path d="M2.5 34.5 L4.2 32.8" stroke="#7c0e1a" strokeWidth="1" />
        <path
          d="M23 13 L29 19 L31.5 16.5 L25.5 10.5 Z"
          fill="#0e0e0e"
        />
        <path
          d="M25.5 10.5 L31.5 16.5 L33 15 L27 9 Z"
          fill="#5a0612"
        />
      </g>
    </svg>
  );
};

export default Cursor;
